import styled from 'styled-components'

const Card = styled.div.attrs({
  trackingData: { category: 'Engagement', event: 'Open Apartment Website', label: '' },
})`
  display: flex;
  flex-direction: ${props => (props.isGrid ? 'column' : 'row')};
  text-decoration: none;
  background: ${props => props.theme.colors.white};
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1), 0px 2px 5px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;
  padding: 0;
  align-items: flex-start;
  color: ${props => props.theme.colors.black};

  &:hover {
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.11), 0px 4px 26px rgba(0, 0, 0, 0.06);
    text-decoration: none;
  }
`

export default Card
